// apps/web/src/components/landing-v2/MarketingFooter.tsx
import { Link } from 'react-router-dom'

/** Marketing footer with product / support / legal columns.
 *  Attribution per handoff: "Made with patience by our practitioners." */
export function MarketingFooter() {
  return (
    <footer className="border-t border-hairline bg-cosmic-topbar/60 mt-16">
      <div className="mx-auto grid max-w-[1280px] gap-10 px-5 py-12 md:grid-cols-2 md:px-8 lg:grid-cols-5">
        <div>
          <p className="font-display text-base tracking-[0.12em] font-light">
            The <span className="text-gold">Cosmic</span> Finder
          </p>
          <p className="mt-3 text-sm text-text-muted">A reading whenever you need one.</p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-text-muted">Product</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/" className="text-text-secondary hover:text-text-primary">What's inside</Link></li>
            <li><Link to="/pricing" className="text-text-secondary hover:text-text-primary">Pricing</Link></li>
            <li><Link to="/how-it-works" className="text-text-secondary hover:text-text-primary">How it works</Link></li>
            {/* Public install route — the only path an iPhone visitor has, since
                iOS never fires a native install prompt. */}
            <li><Link to="/install" className="text-text-secondary hover:text-text-primary">Get the app</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-text-muted">Support</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/help" className="text-text-secondary hover:text-text-primary">Help center</Link></li>
            <li><a href="mailto:hello@thecosmicfinder.com" className="text-text-secondary hover:text-text-primary">hello@thecosmicfinder.com</a></li>
            <li><Link to="/about" className="text-text-secondary hover:text-text-primary">About</Link></li>
          </ul>
        </div>

        {/* Keyword-anchor links to the prerendered SEO pillar pages. Without
            these the pillars are orphans — reachable only from the sitemap —
            so crawlers assign them near-zero internal PageRank. */}
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-text-muted">Guides</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/oracle-card-reading-reno" className="text-text-secondary hover:text-text-primary">Oracle card reading in Reno</Link></li>
            <li><Link to="/oracle-reading-app" className="text-text-secondary hover:text-text-primary">What is an oracle reading app?</Link></li>
            <li><Link to="/pull-a-card" className="text-text-secondary hover:text-text-primary">How to pull a card</Link></li>
            <li><Link to="/astrological-weather" className="text-text-secondary hover:text-text-primary">Astrological weather</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-text-muted">Legal</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/terms" className="text-text-secondary hover:text-text-primary">Terms</Link></li>
            {/* Privacy section lives on /terms — re-add #privacy once TermsPage
                gets a dedicated id="privacy" anchor. */}
            <li><Link to="/terms" className="text-text-secondary hover:text-text-primary">Privacy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-hairline-faint py-5 text-center text-xs text-text-muted">
        Made with patience by our creators.
      </div>
    </footer>
  )
}
